export default __webpack_public_path__ + "locales/sr-Latn-RS/DowngradePlanDialog.json?hash=bc6676b1e536b30fb39fbeddac2630ca";